// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"SubnetsPage_tableContainer__1kOLc","newSubnetText":"SubnetsPage_newSubnetText__3SxGc"};